import React, { useState } from 'react';
import s from './ToolsButtons.module.css';
import IconCopy from '../../../../shared/ui/icons/IconCopy';

interface CopyButtonProps {
    value: string;
    isActive?: boolean;
    onClick?: () => void;
    quillRef: React.RefObject<any>;
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, isActive, onClick, quillRef }) => {
    const [buttonText, setButtonText] = useState('Copy');

    const handleCopy = async () => {
        if (onClick) onClick();

        try {
            // 1) strip HTML tags and normalize line breaks
            const plainText = value
                .replace(/<br\s*\/?>/g, '\n')
                .replace(/<\/p>/g, '\n\n')
                .replace(/<\/?[^>]+(>|$)/g, '')
                .replace(/\n{3,}/g, '\n\n')
                .trim();

            let textToCopy = plainText;

            // 2) if Quill is mounted, see if there's a selection
            if (quillRef.current) {
                const editor = quillRef.current.getEditor();
                const range = editor.getSelection();
                if (range && range.length > 0) {
                    const selectedText = editor.getText(range.index, range.length);
                    textToCopy = selectedText;
                }
            }

            // 3) copy it
            await navigator.clipboard.writeText(textToCopy);
            setButtonText('Copied!');

            setTimeout(() => setButtonText('Copy'), 2000);
        } catch (error) {
            console.error('Failed to copy content:', error);
            alert('Failed to copy content.');
        }
    };

    return (
        <button className={s.container} onClick={handleCopy}>
            <IconCopy />
            <p>{buttonText}</p>
        </button>
    );
};

export default CopyButton;
